var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-chip',{staticClass:"min-width-120",attrs:{"color":"success","icon":"mdi-check-circle-outline","iconColor":"white","text-color":"white"}},[_vm._v(" "+_vm._s(_vm.$t("commons.status.approved"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }